import { useMutation } from '@tanstack/react-query';

import { OilStoreTypeService } from 'services/openapi';
import type { UpdateStoreTypeDto } from 'services/openapi';

import { OIL_STORE_TYPE_MUTATION_KEYS } from './constants';

interface UpdateOilStoreTypeParams {
  id: string;
  data: UpdateStoreTypeDto;
}

export const useUpdateOilStoreTypeMutation = () => {
  return useMutation({
    mutationKey: [OIL_STORE_TYPE_MUTATION_KEYS.UPDATE],
    mutationFn: ({ id, data }: UpdateOilStoreTypeParams) =>
      OilStoreTypeService.oilStoreTypeControllerUpdate(id, data),
  });
};
